// client/src/context/reducers/knowledgeReducer.js

const knowledgeReducer = (state, { type, payload }) => {
  switch (type) {
    case 'LIST_KNOWLEDGE_POSTS':
      return { 
        ...state, 
        isKnowledgeLoaded: false, 
        knowledgePostsCount: payload 
      };

    case 'LOAD_KNOWLEDGE_POSTS':
      return { 
        ...state, 
        isKnowledgeLoaded: true, 
        knowledgePosts: payload 
      };
        
    case 'ADD_KNOWLEDGE_POST':
      return { 
        ...state, 
        knowledgePosts: [payload, ...state.knowledgePosts]
      };

    case 'UPDATE_KNOWLEDGE_POST':
      return {
        ...state,
        knowledgePosts: state.knowledgePosts.map(post => 
          post.filename === payload.filename ? payload : post
        )
      };

    case 'DELETE_KNOWLEDGE_POST':
      return {
        ...state,
        knowledgePosts: state.knowledgePosts.filter(
          post => post.filename !== payload
        )
      };

    case 'UPDATE_KNOWLEDGE_NOTIFICATIONS':
      return {
        ...state,
        isKnowledgeLoaded: true,
        knowledgePosts: payload.knowledgePosts,
        newKnowledgeCount: payload.newKnowledgeCount,
        newKnowledgeFileNames: payload.newKnowledgeFileNames,
      };

    case 'KNOWLEDGE_ERROR':
      return { 
        ...state, 
        error: payload, 
        isKnowledgeLoaded: false
      };
        
    default:
      return state;
  }
};

export default knowledgeReducer;